export class Number {
    value: number;
    model: string;
    sign: string;
    inValid: boolean;
}


// WEBPACK FOOTER //
// ./src/app/modules/el-data-management/eldm-filters/entities/number-model.ts